import { render, staticRenderFns } from "./smartnavigationSystem.vue?vue&type=template&id=565fee6a&scoped=true"
import script from "./smartnavigationSystem.vue?vue&type=script&lang=js"
export * from "./smartnavigationSystem.vue?vue&type=script&lang=js"
import style0 from "./smartnavigationSystem.vue?vue&type=style&index=0&id=565fee6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565fee6a",
  null
  
)

export default component.exports